/** Sponsor admin grids (orgs + users) — FE column key → API sort_by. */

import { pickTabSortParams, sortConfigToApiParams as mapSortConfig } from "./gridSortApiParams";

export const SPONSOR_ADMIN_USE_SERVER_SORT = true;

export const SPONSOR_ORG_API_SORT_FIELD = {
  sponsor_name: "sponsor_name",
  primary_location: "primary_location",
  is_active: "is_active",
  created: "created_at",
  requests_count: "requests_count",
};

export const SPONSOR_USER_API_SORT_FIELD = {
  name: "name",
  organization: "organization",
  title: "title",
  email: "email",
  is_active: "is_active",
  role: "role",
  portal_access: "portal_access",
  created_at: "created_at",
};

export function sortConfigToSponsorOrgApiParams(sortConfig, enabled = SPONSOR_ADMIN_USE_SERVER_SORT) {
  return mapSortConfig(sortConfig, SPONSOR_ORG_API_SORT_FIELD, enabled);
}

export function sortConfigToSponsorUserApiParams(sortConfig, enabled = SPONSOR_ADMIN_USE_SERVER_SORT) {
  return mapSortConfig(sortConfig, SPONSOR_USER_API_SORT_FIELD, enabled);
}

export function resolveSponsorAdminTabSortParams(activeTab, sortConfig) {
  const orgSortParams =
    activeTab === "organizations" ? sortConfigToSponsorOrgApiParams(sortConfig) : undefined;
  const userSortParams =
    activeTab === "users" ? sortConfigToSponsorUserApiParams(sortConfig) : undefined;
  return {
    orgSortParams,
    userSortParams,
    serverSortParams: pickTabSortParams(activeTab, orgSortParams, userSortParams),
  };
}
